export default "__VITE_ASSET__Dl$0k83v__"